/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IModalStyles } from '@fluentui/react/lib/Modal';
import { IStyle } from '@fluentui/react/lib/Styling';
import { ModalSize } from '../../../data/types.generated';
import { getAppHost } from '../../../utilities/TeamsUtils';
import { getHTMLDir } from '../../../utilities/Utils';

export const getModalStyles = (size: ModalSize): Partial<IModalStyles> => {
    const dismissButtonStyles: IStyle = {
        position: 'absolute',
        top: '22px',
        zIndex: 20,
    };

    if (getHTMLDir(getAppHost().getLocaleName()) === 'rtl') {
        dismissButtonStyles.left = '15px';
    } else {
        dismissButtonStyles.right = '15px';
    }
    // Set the dialog body medium size height and width to 600px, same as task module iframe's height
    const width = size === ModalSize.Large ? '95vw' : '600px';
    const height = size === ModalSize.Large ? '100vh' : '600px';

    return {
        scrollableContent: {
            width,
            height,
            // Add a max height to be inline with FluentUI Modal Component's max height
            maxHeight: 'calc(100vh - 115px)',
            overflow: 'hidden',
            paddingTop: '1.875rem',
            selectors: {
                '.modal-dismiss-button': dismissButtonStyles,
            },
        },
    };
};
